<template>
  <span>
    <v-btn icon small flat @click.stop="fetchCompanies" :loading="loadingCompanies">
      <v-icon small color="primary">mdi-card-account-details-outline</v-icon>
    </v-btn>

    <!-- Company selection dialog -->
    <v-dialog v-model="companySelectDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <h3>{{ $t('Seleccionar empresa') }}</h3>
        </v-card-title>
        <v-list>
          <v-list-tile
            v-for="company in companies"
            :key="company.clavedat"
            @click="selectCompany(company.clavedat)"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ company.company_name }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ company.clavedat }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon color="primary">mdi-chevron-right</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="companySelectDialog = false">{{ $t('Cancelar') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- No companies snackbar -->
    <v-snackbar v-model="noCompanies" :timeout="3000" top color="warning">
      {{ $t('Este usuario no tiene empresas asociadas') }}
    </v-snackbar>

    <!-- Fullscreen fiscal data dialog -->
    <v-dialog fullscreen v-model="fiscalDetailDialog">
      <customer-data-form
        v-if="configLoaded && fiscalDetailDialog"
        :config="config"
        :edit-index="-1"
        :edit-item="editedItem"
        @closeDialog="closeFiscalDetail"
      ></customer-data-form>
    </v-dialog>
  </span>
</template>

<script>
import ProfileAPI from '@/services/api/profile.js';
import FiscalAPI from '@/modules/admin/aplifisa/services/fiscal.js';
import CustomerDataForm from '@/modules/admin/aplifisa/components/CustomerDataForm.vue';

export default {
  components: {
    CustomerDataForm,
  },
  props: {
    userId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loadingCompanies: false,
      companies: [],
      companySelectDialog: false,
      noCompanies: false,
      fiscalDetailDialog: false,
      editedItem: null,
      config: {},
      configLoaded: false,
    };
  },
  methods: {
    fetchCompanies() {
      this.loadingCompanies = true;
      ProfileAPI.getCompaniesOfUsers([this.userId])
        .then(response => {
          this.companies = response.data.data;
          if (this.companies.length === 0) {
            this.noCompanies = true;
          } else if (this.companies.length === 1) {
            this.selectCompany(this.companies[0].clavedat);
          } else {
            this.companySelectDialog = true;
          }
        })
        .finally(() => {
          this.loadingCompanies = false;
        });
    },
    selectCompany(clavedat) {
      this.companySelectDialog = false;
      this.loadingCompanies = true;
      FiscalAPI.getFiscalDetail(clavedat)
        .then(response => {
          this.editedItem = response.data.data.fiscal_data;
          this.config = response.data.data.config;
          this.configLoaded = true;
          this.fiscalDetailDialog = true;
        })
        .finally(() => {
          this.loadingCompanies = false;
        });
    },
    closeFiscalDetail() {
      this.fiscalDetailDialog = false;
      this.editedItem = null;
      this.configLoaded = false;
    },
  },
};
</script>
